import { Route } from '@angular/router';
import { provideStates } from '@ngxs/store';
import { ExcursionsApiService } from './services/excursions-api.service';
import { ExcursionsSearchFormService } from './services/excursions-search-form.service';
import { ExcursionsState } from './state/excursions.state';

/** TravelDesk Plan 2b - the Excursions tab (D-21a), on the avia-page pattern. */
export const excursionsPageRouteConfig: Route = {
  path: 'excursions',
  loadComponent: () => import('./excursions-page.component').then((c) => c.ExcursionsPageComponent),
  providers: [provideStates([ExcursionsState]), ExcursionsApiService, ExcursionsSearchFormService]
};
